<template>
    <div>
        <el-dialog
        title="批量导出客户"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose">
            <div class="content">
                <ul class="checkTab mb-30">
                    <li :class="{'active':types==1 || types==2 || types==3}">
                        <p>1</p>
                        <p>确认导出数据</p>
                    </li>
                    <li :class="{'active':types==2 || types==3}">
                        <p>2</p>
                        <p>签署客户数据导出协议</p>
                    </li>
                    <li  :class="{'active':types==3}">
                        <p>3</p>
                        <p>客户数据导出</p>
                    </li>
                </ul>
                <div v-show="types==1">
                <div class="title mb-30">
                    <img src="../../../assets/images/newIcon/group_tishi_icon.png" alt="">
                    导出完成时间跟数据量有关，预计在1小时以内，导出过程中的数据变动不会被记录
                </div>
                <div class="text mb-30">
                    <p class="t mb-30">查询条件：</p>
                    <div class="c">
                        <div>
                            <p><span>注册时间：</span>2021-08-01 00:00:00 至 2021-08-31 00:00:00</p>
                            <p><span>添加时间：</span>2021-08-01 00:00:00 至 2021-08-31 00:00:00</p>
                        </div>
                        <div>
                            <p><span>活跃时间：</span>2021-08-01 00:00:00 至 2021-08-31 00:00:00</p>
                            <p><span>活动参与次数：</span>参与x次/从未参与</p>
                        </div>
                        <div>
                            <p><span>优惠券领取：</span>是</p>
                            <p><span>积分筛选：</span>100-200</p>
                        </div>
                        <div>
                            <p><span>优惠券使用：</span>是</p>
                            <p><span>消费金额：</span>100-200</p>
                        </div>
                        <div>
                            <p><span>会员来源：</span>小程序模版消息</p>
                            <p><span>会员等级：</span>黄金会员</p>
                        </div>
                        <div>
                             <span style="    width: 100px;
    text-align: right;">会员标签：</span>
                            <p class="labs">
                               
                                <span class="lab">
                                    <i>标签标签</i>
                                    <i>标签标签</i>
                                    <i>标签标签</i>
                                    <i>标签标签</i>
                                    <i>标签标签</i>
                                    <i>标签标签</i>
                                    <i>标签标签</i>
                                    <i>标签标签</i>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="tabf">
                    <p class="mb-30">报表字段：</p>
                    <p>
                        <span>ID</span>
                        <span>名称</span>
                        <span>手机号码</span>
                        <span>来源</span>
                        <span>注册时间</span>
                        <span>性别</span>
                        <span>地区</span>
                        <span>标签</span>
                        <span>会员积分</span>
                        <span>消费次数</span>
                        <span>用券订单</span>
                        <span>会员价值</span>
                        <span>客单价</span>
                    </p>
                </div>
                      
                </div>
                <div class="tab2" v-show="types==2">
                    <p class="t">数据导出承诺函</p>
                    <div class="contet">
                        <p class="ft">一.导语</p>
                        <p>(一) <span>【审慎阅读】</span> 当商家点击 <span>“同意本承诺函并导出”</span>之前，请务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，商家应重点阅读。如商家对承诺函有任何疑问，可向积木客服咨询。</p>
                        <p>(二) <span>【签约流程】</span> 当商家按照页面提示完成操作后，即表示商家 <span>已充分阅读、理解并接受本承诺函的全部内容</span>。阅读本承诺函的过程中，如果商家不同意本承诺函或其中任何条款约定，商家应立即停止签约流程。 </p>
                        <p>(三) <span>【适用范围】</span> 为了在数据输出方 <span>（深圳市积木创意科技有限公司）</span>和数据输入方（以下简称“商家”）之间的数据导出过程中及数据导出后，保护用户的个人数据及商家的运营数据。商家需要遵守本承诺函的全部内容，确保合法使用数据并采取足够的安全措施。</p>
                    </div>
                    <div class="contet">
                        <p class="ft">二.定义</p>
                        <p>(一) <span>【数据输出方】</span> 指负责处理个人数据和/或运营数据导出的一方。（深圳市积木创意科技有限公司，以下简称“积木”）</p>
                        <p>(二) <span>【数据输入方】</span> 指同意从数据输出方接收个人数据和/或运营数据，并根据法律的规定及本承诺函的约定，将所收到的个人数据和/或运营数据进行合理使用及保存的数据接收方（以下简称“商家”）。</p>
                        <p>(三) <span>【个人数据】</span> 指注册用户包括但不限于在使用积木产品/服务及订购和使用商家产品/服务过程中提供及使用产生的数据。</p>
                        <p>(四) <span>【个人数据】</span> 指注册用户包括但不限于在使用积木产品/服务及订购和使用商家产品/服务过程中提供及使用产生的数据。</p>
                        <p>(五) <span>【运营数据】</span> 指商家在使用积木提供的产品/服务的过程中产生的相关数据，包括但不限于商家在使用积木提供的产品/服务过程中因操作行为形成的数据、各类交易数据、消费者/用户产生的与商家有关的数据。</p>
                        <p>(六) <span>【用户】</span> 指在积木平台进行注册的自然人、法人及其他组织。</p>
                        <p>(七) <span>【消费者】</span> 指与商家的店铺发生关联行为或在商家的店铺购买任何商品或服务的买家。</p>
                    </div>
                   
                    <div class="contet">
                        <p class="ft">三.承诺函的效力</p>
                        <p>(一) <span>【承诺函的生效】</span>本承诺函自商家按照页面提示点击“同意本承诺函并导出”即生效，商家需遵守本承诺函的全部内容。</p>
                        <p>(二) <span>【承诺函的有效期】</span> 本承诺函自生效之日起，除非商家与积木另有约定或法律法规有相关要求，否则永久有效。</p>
                        <p>(三) <span>【承诺函变更】</span>积木可基于国家法律法规变化、业务调整、产品更新及维护交易秩序、保护消费者权益等需要对承诺函内容进行变更，变更后的承诺函将按照法定程序在积木规则中心（https://www.youzan.com/intro/rule/index）进行公示。如商家不同意变更内容，商家有权于变更内容确定的生效日前联系积木反馈意见，积木将根据商家的反馈酌情调整变更事项。</p>
                       
                    </div>
                    <div class="contet">
                        <p class="ft">四.数据导出内容</p>
                        <p>(一) <span>【内容确定】</span>商家可根据实际需要向积木申请需要积木导出的数据内容。</p>
                        <p>(二) <span>【导出流程】</span> 商家需要按照积木页面提示的操作流程进行数据导出，未严格按照页面流程操作造成的数据瑕疵（包括但不限于数据缺失、数据有误、数据泄露）产生的后果均由商家自行承担。</p>
                        <p>(三) <span>【权利归属】</span>数据导出内容积木已经按照法律规定获得相关授权或享有数据的所有权。</p>
                       
                    </div>
                    
                    <div class="contet">
                        <p class="ft">五.数据输入方的义务</p>
                        <p>(一) <span>【数据使用】</span>商家承诺仅在积木同意的使用范围内按照本承诺函的约定及法律规定使用获得的数据。</p>
                        <p>(二) <span>【数据删除】</span> 包括但不限于因法律规定、积木获得的数据授权失效、数据所有权人的要求、商家与积木合作终止或积木导出数据的授权使用期限到期等原因，积木、数据所有权人或基于司法裁判及行政决定，要求商家删除或停止使用获得数据的，商家应在在规定期限内删除相关数据并停止使用。</p>
                        <p>(三) <span>【数据安全】</span>商家应自行对基于本承诺函而获取的各种数据，采取合理安全的技术措施确保其安全。</p>
                        <p>(四) <span>【数据再授权】</span>未经积木书面同意，商家不得将获得的数据再授权给任意第三方使用。如基于司法裁判及行政决定要求商家将数据提供给第三方的或出现意外情况泄露给第三方，商家应立即通知积木。如经积木书面同意，商家可将数据授权给第三方使用，商家需保证该第三方亦需遵守本承诺函的所有约定，且商家需与该第三方在该第三方存在违反本承诺函约定的行为时而产生的所有责任与其承担连带责任。</p>
                        <p>(五) <span>【员工数据使用】</span>商家的员工可能会基于商家的提供或通过商家授权的积木店铺账号使用权限获得基于本承诺函商家获得的数据。商家应保证该员工亦需遵守本承诺函的所有约定。该员工的行为即视为商家的行为。</p>
                    </div>
                    <div class="contet">
                        <p class="ft">六.违约责任</p>
                        <p style="margin:0">(一) 商家承诺，商家及商家的员工须遵守本承诺函的全部约定及法律规定，违反本承诺函的约定及法律规定产生的责任均由商家自行承担。</p>
                        <p style="margin:0">(二) 如商家违反本承诺函的约定，积木有权要求商家立即删除并停止使用导出数据，并有权终止/解除与商家的所有合作。但合作的解除/终止不免除或减少商家因违反本承诺函约定需要承担的责任。</p>
                        <p style="margin:0">(三) 如商家违反本承诺函约定，积木有权按实际损失追究商家的违约责任。</p>
                        
                    </div>
                    <div class="contet">
                        <p class="ft">七.本承诺函的解释法律适用及争端解决</p>
                        <p style="margin:0">(一) 本承诺函适用中华人民共和国大陆地区法律。</p>
                        <p style="margin:0">(二) 本承诺函签订地为中国杭州市西湖区。因本承诺函所引起商家的与积木的任何纠纷或争议，商家同意将纠纷或争议提交向积木所在地有管辖权的法院提起诉讼。</p>
                    </div>
                </div>
                <div class="tab3" v-show="types==3">
                    <p><img src="../../../assets/images/newIcon/chenggong_icon.png" alt=""></p>
                    <p>导入成功</p>
                    <p>可在右上角是查看文件下载进度</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" v-if="types==1">取 消</el-button>
                <el-button @click="goType(1)" v-if="types!=1 && types!=3">上一步</el-button>
                <el-button type="primary" v-if="types!=3"  @click="goType(2)">{{types==2 ? '同意本承诺单并导出' : '下一步'}}</el-button>
                <el-button type="primary" v-if="types==3" @click="dialogVisible=false;">完成</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props:{
        
    },
    data() {
        return {
            dialogVisible:false,
            types:1,
            titles:["","修改客户等级","修改客户积分","批量打客户标签","选择标签"],
            tags:["成交拉","核心"]
        }
    },
    methods: {
        goType(t){
            if(t==1){
                this.types=--this.types;
            }else{
                this.types=++this.types;
            }
        },
        show(item){
            this.dialogVisible=true;
        },
        hidelod(){
            this.dialogVisible=false;
            this.types=0;
        },
        cong(){
            if(this.types==1 ||this.types==2){//等级 或积分
                let a=this.$refs.customerLevel.set();
                this.$emit("doSelect",a);
                this.dialogVisible=false;
            }else if(this.types==3 || this.types==4){//打标签
                let tags=this.$refs.customerLabel.set();
                if(this.types==3){
                    this.dialogVisible2=true;
                }else{
                    this.$emit("doSelect",tags);
                }
                this.dialogVisible=false;
            }
            this.types=0;
            
        },
        config(){
            this.$emit("doSelect",this.tags);
            this.dialogVisible2=false;
        },
        handleClose(e){
            this.dialogVisible=false;
            this.types=1;
            // this.types=0;
        },
        handleClose2(){
            this.dialogVisible2=false;
            this.dialogVisible=true;
        }
    },
}
</script>
<style lang="less" scoped>
.content{
    height:500px;
    overflow-y:auto;
    padding:30px;
    .checkTab{
        display: flex;
        justify-content: center;
        li{
            margin-right:180px;
            position: relative;
            &:last-child{
                margin:0;
                &::after{
                    left: -198px;
                }
            }
            &:first-child{
                
                &::after{
                    display:none;
                }
                
            }
            &:nth-child(2){
                &::after{
                    left: -171px;
                }
                
            }
            
            &::after{
                content: '';
                position: absolute;
                top: 20px;
                border-bottom: 1px dashed #A7A7A7;
                width: 190px;
                height: 2px;
            }
        }
        .active{
            &::after{
                border-bottom: 1px dashed #327EFF;
            }
            p{
                &:last-child{
                    color: #327EFF;
                }
                &:first-child{
                    background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                    color:#fff;
                }
            }
        }
        p{
            text-align: center;
            &:first-child{
                margin:0 auto;
                margin-bottom:15px;
                width: 44px;
                height: 44px;
                border-radius: 50%;
                line-height: 44px;
                text-align: center;
                background: #EBEBEB;
                font-size: 22px;
                font-weight: 500;
                color: #A1A1A1;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #A1A1A1;
            }
        }
    }
    .title{
        padding:15px;
        background: rgba(73, 116, 251, 0.11);
        border-radius: 4px;
        img{
            width:16px;
            height:16px;
            vertical-align: middle;
        }
        font-size: 14px;
        font-weight: 400;
        color: #258EF7;
    }
    .text{
        .t{
            font-size: 14px;
            font-weight: 400;
            color: #777777;
        }
        .c{
            background: #F9F9F9;
            border-radius: 6px;
            padding:30px;
            div{
                margin-bottom:15px;
                display: flex;
                p{
                    width:50%;
                    span{
                        display: inline-block;
                        width:100px;
                        text-align: right;
                    }
                    .lab{
                        width:350px;
                        text-align: left;
                        i{
                            margin-bottom:10px;
                            margin-right:8px;
                            display: inline-block;
                            padding:4px 10px;
                            font-style:normal;
                            background: #D3ECFF;
                            border-radius: 15px;
                            border: 1px solid #A9D9FF;
                            color:#0091FF;
                        }
                        
                    }
                }
                .labs{
                    display: flex;
                }
                // justify-content: space-between;
            }
           
        }
    }
    .tabf{
        span{
            margin-right:10px;
            margin-bottom:10px;
            display: inline-block;
            min-width: 88px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background: rgba(236, 247, 255, 0.7);
            border-radius: 15px;
            font-size: 12px;
            font-weight: 400;
            color: #3E86FF;
        }
    }
    .tab2{
        padding:30px;
        background: #F9F9F9;
        .t{
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #333333;
        }
        .contet{
                margin-bottom: 40px;
            .ft{
                color:#333;
            }
            p{
                margin-bottom:15px;
                span{
                    color:#333333;
                }
            }
        }
    }
    .tab3{
        padding:100px 0;
        background: #F9F9F9;
        border-radius: 6px;
        p{
            margin-bottom:15px;
            text-align: center;
            img{
                width:68px;
                height:68px;
            }
            &:nth-child(2){
                font-size: 18px;
                font-weight: 400;
                color: #333333;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #777777;
            }
        }
    }
}
.dlog{
    padding:30px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    span{
        color:#327EFF;
    }
}
    .dialog-footer{
        display: block;
      
        .el-button{
            border-radius: 30px;
        }
    }
    /deep/ .el-dialog__footer{
          border-top:1px solid #ededed;
    }
</style>